export default "__VITE_ASSET__Dq8lbXpH__"